import { AvailabilityRulesMutations } from './partials/availability-rules'
import { AvailabilitySlotsMutations } from './partials/availability-slots'
import { LinkedCalendarsMutations } from './partials/linked-calendars'
import { PermissionMutations } from './partials/permissions'
import { SchedulingAssistantMutations } from './partials/scheduling-assistant'

export const CalendarMutations = {
  ...PermissionMutations,
  ...AvailabilityRulesMutations,
  ...AvailabilitySlotsMutations,
  ...LinkedCalendarsMutations,
  ...SchedulingAssistantMutations,

  setSelectedCalendarDate: (state, date) => {
    state.selectedCalendar.date = date
  },

  setSelectedCalendarEvents: (state, events) => {
    state.selectedCalendar.events = events
  },

  setSelectedCalendarEventsCount: (state, value) => {
    state.selectedCalendar.eventsCount = value
  },

  setSelectedCalendarTimezone: (state, timezone) => {
    state.selectedCalendar.timezone = timezone
  },

  setSelectedCalendarUserId: (state, userId) => {
    state.selectedCalendar.userId = userId
  },

  setSharedCalendars: (state, payload) => {
    state.sharedCalendars = payload
  },

  setAppointmentTypes: (state, values) => {
    state.appointmentTypes = values
  },

  setTimezones: (state, values) => {
    state.timezones = values
  },
}
